module.exports = __webpack_public_path__ + "img/linkedin-icon.29f4090.svg";